import * as _ from 'lodash';
import {
  LIST_GHOST_PRODUCTS_SUCCEEDED,
  LIST_GHOST_PRODUCTS_REQUESTED,
  CREATE_GHOST_PRODUCTS_REQUESTED,
  CREATE_GHOST_PRODUCTS_SUCCEEDED, PRINT_GHOST_PRODUCT_SUCCEEDED, CREATE_GHOST_PRODUCTS_COMPLETED, PRINT_GHOST_PRODUCT_REQUESTED
} from './ghost.actions';
import {PRINT_COMPLETED} from "../../../store/print/print.actions";

export const ghost = (state = { created: false, fetched: false, items: [], loading: false, observedCode: '', printData: null, printCompleted: false}, action) => {
  switch (action.type) {
    case LIST_GHOST_PRODUCTS_SUCCEEDED:
      return _.assign(state, {
        fetched: true,
        items: action.data,
        loading: false
      });
    case LIST_GHOST_PRODUCTS_REQUESTED:
      return _.assign(state, {
        fetched: false,
        loading: true
      });
    case CREATE_GHOST_PRODUCTS_REQUESTED:
      return _.assign(state, {
        loading: true,
        created: false
      });
    case CREATE_GHOST_PRODUCTS_SUCCEEDED:
      return _.assign(state, {
        loading: false,
        created: true,
        observedCode: action.data
      });
    case CREATE_GHOST_PRODUCTS_COMPLETED:
      return _.assign(state, {
        observedCode: ''
      });
    case PRINT_GHOST_PRODUCT_REQUESTED:
      return _.assign(state, {
        printData: action.code,
        printCompleted: false
      });
    case PRINT_GHOST_PRODUCT_SUCCEEDED:
      return _.assign(state, {
        fetched: true,
        items: action.data ? action.data : state.items,
        loading: false,
        printData: null,
        printCompleted: false
      });
    case PRINT_COMPLETED:
      if (state.printData) {
        return _.assign(state, {
          printCompleted: true
        });
      } else {
        return _.assign(state, {});
      }
    default:
      return state;
  }
};
